export default {
      id: "user-hiring-managers-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#user-hiring-managers-usage",
      toString: function () {
        return this.url;
      }
    }